
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ExtendedRole } from "../types";

export interface RoleSelectProps {
  value: ExtendedRole;
  onRoleChange: (value: ExtendedRole) => void;
}

export const RoleSelect = ({ value, onRoleChange }: RoleSelectProps) => {
  const roles: ExtendedRole[] = ["admin", "producer", "user", "client"];

  // Format role for display by capitalizing first letter
  const formatRole = (role: string) => {
    return role.charAt(0).toUpperCase() + role.slice(1);
  };

  return (
    <Select value={value} onValueChange={onRoleChange}>
      <SelectTrigger>
        <SelectValue placeholder="Select a role">
          {value ? formatRole(value) : "Select a role"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {roles.map((role) => (
          <SelectItem key={role} value={role}>
            {formatRole(role)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
